'use client';

import type { ComponentPropsWithoutRef, FC, ReactNode } from 'react';
import Link from 'next/link';
import { Button } from './button';

type TButtonProps = ComponentPropsWithoutRef<typeof Button>;

type TLinkButton = {
  href: string;
  children: ReactNode;
  className?: string;
  variant?: TButtonProps['variant'];
  size?: TButtonProps['size'];
  startIcon?: TButtonProps['startIcon'];
};

// Small client island: Button is a client component with a polymorphic `as`
// prop, so server components can't hand it a Link reference directly.
export const LinkButton: FC<TLinkButton> = ({ href, children, className, variant, size, startIcon }) => (
  <Button as={Link} href={href} className={className} variant={variant} size={size} startIcon={startIcon}>
    {children}
  </Button>
);
